import React, { useState, useEffect } from "react";
import axios from "axios";

import { Modal } from "react-bootstrap";
// import DownArrow from "../../../asset/images/down-arrow.svg";
import Lowarrow from "../../../asset/images/low-arrow.svg";
import UpArrow from "../../../asset/images/up-arrow.svg";
import { Constants } from "../../../CommonMethhods/Constants";
// import Loader from "../Common/Loader";
import {
  forToFix,
  numDifferentiationWithoutSymbol,
} from "../../../CommonMethhods/CovertRupees";
import { DASHBOARD_DEFAULT } from "../../../Configuration/API_URL";
import {
  AESEncryption,
  ApiResDecrypt,
  checkEmpty,
  getTabStatus,
  goToClientDashboard,
  noDataFound,
} from "../../../CommonMethhods/CommonMethods";
import Loader from "../../Common/Loader";
import { get } from "jquery";
import SmallLoader from "../../Common/smallLoader";
import { toast } from "react-toastify";

function RevenueSnapshot(props) {
  const storeToken = localStorage.getItem("ssoToken");
  const [revenueEquModel, setRevenueEquModel] = useState([]);
  const [revenueMTFModel, setRevenueMTFModel] = useState([]);
  const [revenueFnoModel, setRevenueFnoModel] = useState([]);
  const [showModal, setShowModal] = useState(false);
  const [showModelFno, setShowModelFno] = useState(false);
  const [page, setPage] = useState(1);
  const [showModelMTF, setShowModelMTF] = useState(false);
  // const [pageSize, setPageSize] = useState(5);

  const revenueTable = props.revenueTableData;
  const [loader, setLoader] = useState(true);
  // const [infiniteScrollLoader, setInfiniteScrollLoader] = useState(false);
  const [duration, setDuration] = useState("");
  const [smallLoaderExcel, setSmallLoaderExcel] = useState(false);
  const [smallLoaderPdf, setSmallLoaderPdf] = useState(false);
  const title = props.title.split(" ")[0];
  const [fileType, setFileType] = useState("grid");
  const firstColumnTitle = title === "Sales" ? "Turnover" : title;
  const [serverError, setServerError] = useState("");
  const yesterday = revenueTable.yesterday;
  // const overall = revenueTable.yesterday;
  const weekly = revenueTable.weekly;
  const month = revenueTable.monthly;
  const year = revenueTable.yearly;

  const rowLabels = ["Equity", "MTF", "F&O", "Total"];

  // const handleifTableEmptyoverall = (flag) => {
  //   const tempArray = [[0], [0], [0], [0]];

  //   return tempArray.map((column, index) => {
  //     return (
  //       <tr key={index}>
  //         {flag === true ? (
  //           <th className="text-left header-width">{rowLabels[index]}</th>
  //         ) : (
  //           <th></th>
  //         )}
  //         {column.map((v, index) => {
  //           return (
  //             <td key={index} className="snapshot-table-column">
  //               {"0"}
  //             </td>
  //           );
  //         })}
  //       </tr>
  //     );
  //   });
  // };

  const handleifTableEmpty = (flag) => {
    const tempArray = [
      [0, 0, 0, 0],
      [0, 0, 0, 0],
      [0, 0, 0, 0],
      [0, 0, 0, 0],
    ];

    return tempArray.map((column, index) => {
      return (
        <tr key={index}>
          {flag === true ? (
            <th className="text-left header-width">{rowLabels[index]}</th>
          ) : (
            <></>
          )}
          {column.map((v, index) => {
            return (
              <td key={index} className="snapshot-table-column">
                {"0"}
              </td>
            );
          })}
        </tr>
      );
    });
  };
  const getRevenueSnapshotFnoModel = async (
    duration,
    fileData = "grid",
    pageSize = 5
  ) => {
    // setLoader(true);
    if (fileData == "excel") {
      setSmallLoaderExcel(true);
      setSmallLoaderPdf(false);
      setLoader(false);
    } else if (fileData == "pdf") {
      setSmallLoaderExcel(false);
      setSmallLoaderPdf(true);
      setLoader(false);
    } else {
      setSmallLoaderExcel(false);
      setSmallLoaderPdf(false);
    }
    let payloadValue = {
      pageSize: pageSize,
      pageNo: page,
      Duration: duration,
      fileType: fileData,
    };
    let encPayload = AESEncryption(payloadValue);

    try {
      const getRevenueFno = await axios.post(
        DASHBOARD_DEFAULT.RevenueSnapshotFnoModel_URL,
        `"${encPayload}"`,
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${storeToken}`,
            reserv: 1,
          },
        }
      );
      const response = ApiResDecrypt(getRevenueFno?.data);

      const res = response.data;

      if (res) {
        if (showModelFno == true) {
          if (fileData == "grid") {
            setRevenueFnoModel((prev) => {
              return [...prev, ...res.clients];
            });
          } else if (fileData == "pdf") {
            window.open(res, "_blank", "noopener,noreferrer");
          } else {
            window.open(res, "_blank", "noopener,noreferrer");
          }
        } else {
          // setActive(res.eq || res.clients)
          setRevenueFnoModel(res.eq || res.clients);
        }
      }
      setLoader(false);
      // setInfiniteScrollLoader(false);
      setSmallLoaderExcel(false);
      setSmallLoaderPdf(false);
    } catch (error) {
      console.log(error);
      setLoader(false);
      setSmallLoaderExcel(false);
      setSmallLoaderPdf(false);
      setServerError("Something went wrong, Please try again later.");
      if (fileType == "excel") {
        toast.error("Something went wrong, Please try again later.");
      }
      if (fileType == "pdf") {
        toast.error("Something went wrong, Please try again later.");
      }
      // setInfiniteScrollLoader(false);
    }
  };

  const getRevenueSnapshotEquityModel = async (
    duration,
    fileData = "grid",
    pageSize = 5
  ) => {
    // setLoader(true);
    if (fileData == "excel") {
      setSmallLoaderExcel(true);
      setSmallLoaderPdf(false);
      setLoader(false);
    } else if (fileData == "pdf") {
      setSmallLoaderExcel(false);
      setSmallLoaderPdf(true);
      setLoader(false);
    } else {
      setSmallLoaderExcel(false);
      setSmallLoaderPdf(false);
    }
    let payloadValue = {
      pageSize: pageSize,
      pageNo: page,
      Duration: duration,
      fileType: fileData,
    };
    let encPayload = AESEncryption(payloadValue);
    try {
      const getRevenueEquity = await axios.post(
        DASHBOARD_DEFAULT.RevenueSnapshotEquityModel_URL,

        `"${encPayload}"`,
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${storeToken}`,
            reserv: 1,
          },
        }
      );

      const response = ApiResDecrypt(getRevenueEquity?.data);
      const res = response.data;
      if (res) {
        if (showModal == true) {
          if (fileData == "grid") {
            setRevenueEquModel((prev) => {
              return [...prev, ...res.clients];
            });
          } else if (fileData == "pdf") {
            window.open(res, "_blank", "noopener,noreferrer");
          } else {
            window.open(res, "_blank", "noopener,noreferrer");
          }
        } else {
          // setActive(res.eq || res.clients)
          setRevenueEquModel(res.eq || res.clients);
        }
      }
      setLoader(false);
      // setInfiniteScrollLoader(false);
      setSmallLoaderExcel(false);
      setSmallLoaderPdf(false);
    } catch (error) {
      console.log(error);
      setLoader(false);
      // setInfiniteScrollLoader(false);
      setSmallLoaderExcel(false);
      setSmallLoaderPdf(false);
      setServerError("Something went wrong, Please try again later.");
      if (fileType == "excel") {
        toast.error("Something went wrong, Please try again later.");
      }
      if (fileType == "pdf") {
        toast.error("Something went wrong, Please try again later.");
      }
    }
  };

  const getRevenueSnapshotMTFModel = async (
    duration,
    fileData = "grid",
    pageSize = 5
  ) => {
    // setLoader(true);
    if (fileData == "excel") {
      setSmallLoaderExcel(true);
      setSmallLoaderPdf(false);
      setLoader(false);
    } else if (fileData == "pdf") {
      setSmallLoaderExcel(false);
      setSmallLoaderPdf(true);
      setLoader(false);
    } else {
      setSmallLoaderExcel(false);
      setSmallLoaderPdf(false);
    }
    let payloadValue = {
      pageSize: pageSize,
      pageNo: page,
      Duration: duration,
      fileType: fileData,
    };
    let encPayload = AESEncryption(payloadValue);

    try {
      const getRevenueMTF = await axios.post(
        DASHBOARD_DEFAULT.RevenueSnapshotMTFModel_URL,
        `"${encPayload}"`,
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${storeToken}`,
            reserv: 1,
          },
        }
      );
      const response = ApiResDecrypt(getRevenueMTF?.data);

      const res = response.data;

      if (res) {
        if (showModelMTF == true) {
          if (fileData == "grid") {
            setRevenueMTFModel((prev) => {
              return [...prev, ...res.mtfDetails];
            });
          } else if (fileData == "pdf") {
            window.open(res, "_blank", "noopener,noreferrer");
          } else {
            window.open(res, "_blank", "noopener,noreferrer");
          }
        } else {
          // setActive(res.eq || res.clients)
          setRevenueMTFModel(res.mtfDetails);
        }
      }
      setLoader(false);
      // setInfiniteScrollLoader(false);
      setSmallLoaderExcel(false);
      setSmallLoaderPdf(false);
    } catch (error) {
      console.log(error);
      setLoader(false);
      setSmallLoaderExcel(false);
      setSmallLoaderPdf(false);
      setServerError("Something went wrong, Please try again later.");
      if (fileType == "excel") {
        toast.error("Something went wrong, Please try again later.");
      }
      if (fileType == "pdf") {
        toast.error("Something went wrong, Please try again later.");
      }
      // setInfiniteScrollLoader(false);
    }
  };

  const onHide = () => {
    setShowModal(false);
    setPage(1);
    setRevenueEquModel([]);
    setFileType("grid");
  };

  const onHideFno = () => {
    setShowModelFno(false);
    setPage(1);
    setRevenueFnoModel([]);
    setFileType("grid");
  };
  const onHideMTF = () => {
    setShowModelMTF(false);
    setPage(1);
    setRevenueMTFModel([]);
    setFileType("grid");
  };

  const handleFileType = (e) => {
    if (e.target.value) {
      props.handleOnClickSnapFileType(e.target.value, "Revenue");
    }
  };

  const handleViewClick = (column, duration) => {
    setDuration(duration);
    if (column == "equity") {
      setShowModal(true);
      setLoader(true);
      // setPage(1);
      getRevenueSnapshotEquityModel(duration);
    }
    if (column == "fno") {
      setShowModelFno(true);
      setLoader(true);
      getRevenueSnapshotFnoModel(duration);
    }
    if (column == "mtf") {
      setShowModelMTF(true);
      setLoader(true);
      getRevenueSnapshotMTFModel(duration);
    }
  };
  const handleScroll = () => {
    setFileType("grid");
    if (showModal == true) {
      const a = document.querySelector("#revenue-equ");
      if (a.scrollTop + a.offsetHeight + 1 >= a.scrollHeight) {
        setPage((prev) => prev + 1);
        // setInfiniteScrollLoader(true);
        // getRevenueSnapshotEquityModel(duration);
      }
    }
    if (showModelFno == true) {
      const a = document.querySelector("#revenue-fno");
      if (a.scrollTop + a.offsetHeight + 1 >= a.scrollHeight) {
        setPage((prev) => prev + 1);
        // setInfiniteScrollLoader(true);
        // getRevenueSnapshotFnoModel(duration);
      }
    }
    if (showModelMTF == true) {
      const a = document.querySelector("#revenue-mtf");
      if (a.scrollTop + a.offsetHeight + 1 >= a.scrollHeight) {
        setPage((prev) => prev + 1);
        // setInfiniteScrollLoader(true);
        // getRevenueSnapshotMTFModel(duration);
      }
    }
  };

  useEffect(() => {
    if (showModal == true) {
      getRevenueSnapshotEquityModel(duration);
    }
    if (showModelMTF == true) {
      getRevenueSnapshotMTFModel(duration);
    }
    if (showModelFno == true) {
      getRevenueSnapshotFnoModel(duration);
    }
  }, [page, fileType]);

  //  const getRevenueSnapshotFnoModel = async () => {
  //    try {
  //      const getRevenueFno = await axios.post(
  //        DASHBOARD_DEFAULT.RevenueSnapshotEquityModel_URL,
  //        {
  //          pageSize: 5,
  //          pageNo: 1,
  //          Duration: "Weekly",
  //        },
  //        {
  //          headers: {
  //            "Content-Type": "application/json",
  //            Authorization: `Bearer ${storeToken}`,
  //          },
  //        }
  //      );
  //      const res = getRevenueEquity.data.data;
  //      if (res) {
  //        if (showModal == true) {
  //          setRevenueEquModel((prev) => {
  //            return [...prev, ...res.clients];
  //          });
  //        } else {
  //          // setActive(res.eq || res.clients)
  //          setRevenueEquModel(res.eq || res.clients);
  //        }
  //      }
  //      setLoader(false);
  //    } catch (error) {
  //      setLoader(false);
  //    }
  //  };

  const generateOverallTableData = (rows, flag) => {
    return Object.keys(rows).map((column, index) => {
      const columnValues = rows[column];
      rows[column].revenue = rows[column].revenue || 0;
      rows[column].revenueExist = rows[column].revenueExist || 0;
      rows[column].chg = rows[column].chg || 0;
      rows[column].chgper = forToFix(rows[column].chgper) || 0;

      // rows[column].chgper=  rows[column].chgper.toFixed(2) || (rows[column].chgper).toFixed(2) ;

      return (
        <tr key={index} className="snapshot-table-row">
          {flag == true ? (
            <th className="text-left header-width"> {rowLabels[index]}</th>
          ) : (
            <></>
          )}
          <td
            key={index}
            className="snapshot-table-column overall-revenue"
            onClick={() => handleViewClick(column, "Yesterday")}
          >
            <>
              <img
                src={
                  columnValues.chg === 0
                    ? ""
                    : columnValues.chg < 0
                    ? Lowarrow
                    : UpArrow
                }
                alt=""
              />
              <>
                {/* <a
                  className="overall-revenue"
                  onClick={() => handleViewClick(column, "Yesterday")}
                > */}
                {columnValues.revenue == undefined || null
                  ? "0"
                  : numDifferentiationWithoutSymbol(columnValues.revenue)}
                {/* </a> */}
              </>
            </>
          </td>
          <td className="snapshot-table-column">
            <span
              className={
                columnValues.revenueExist == 0
                  ? "text-muted"
                  : columnValues.revenueExist < 0
                  ? "red-txt"
                  : "green-txt"
              }
            >
              {columnValues.revenueExist == undefined || null
                ? "0"
                : numDifferentiationWithoutSymbol(columnValues.revenueExist)}
            </span>
          </td>
          <td className="snapshot-table-column">
            <span
              className={
                columnValues.chg == 0
                  ? "text-muted"
                  : columnValues.chg < 0
                  ? "red-txt"
                  : "green-txt"
              }
            >
              {columnValues.chg == undefined || null
                ? "0"
                : numDifferentiationWithoutSymbol(columnValues.chg)}
            </span>
          </td>
          {/* <br /> */}
          <td className="snapshot-table-column">
            <span
              className={
                columnValues.chgper == 0
                  ? "text-muted"
                  : columnValues.chgper < 0
                  ? "red-txt"
                  : "green-txt"
              }
            >
              {columnValues.chgper == undefined || null
                ? "0"
                : columnValues.chgper}{" "}
              %
            </span>
          </td>
        </tr>
      );
    });
  };

  //handle data
  const generateSnapshotTableData = (rows, flag) => {
    return Object.keys(rows).map((column, index) => {
      const columnValues = rows[column];
      rows[column].revenue = rows[column].revenue || 0;
      rows[column].revenueExist = rows[column].revenueExist || 0;
      rows[column].chg = rows[column].chg || 0;
      rows[column].chgper = forToFix(rows[column].chgper) || 0;

      // rows[column].chgper=  rows[column].chgper.toFixed(2) || (rows[column].chgper).toFixed(2) ;

      return (
        <tr key={index} className="snapshot-table-row">
          {flag == true ? (
            <th className="text-left header-width"> {rowLabels[index]}</th>
          ) : (
            <></>
          )}
          <td
            className="snapshot-table-column overall-revenue"
            onClick={() => handleViewClick(column, flag)}
          >
            <>
              <img
                src={
                  columnValues.chg === 0
                    ? ""
                    : columnValues.chg < 0
                    ? Lowarrow
                    : UpArrow
                }
                alt=""
              />
              <>
                {columnValues.revenue == undefined || null
                  ? "0"
                  : numDifferentiationWithoutSymbol(columnValues.revenue)}
              </>
            </>
          </td>
          <td className="snapshot-table-column">
            <span
              className={
                columnValues.revenueExist == 0
                  ? "text-muted"
                  : columnValues.revenueExist < 0
                  ? "red-txt"
                  : "green-txt"
              }
            >
              {columnValues.revenueExist == undefined || null
                ? "0"
                : numDifferentiationWithoutSymbol(columnValues.revenueExist)}
            </span>
          </td>
          <td className="snapshot-table-column">
            <span
              className={
                columnValues.chg == 0
                  ? "text-muted"
                  : columnValues.chg < 0
                  ? "red-txt"
                  : "green-txt"
              }
            >
              {columnValues.chg == undefined || null
                ? "0"
                : numDifferentiationWithoutSymbol(columnValues.chg)}
            </span>
          </td>
          {/* <br /> */}
          <td className="snapshot-table-column">
            <span
              className={
                columnValues.chgper == 0
                  ? "text-muted"
                  : columnValues.chgper < 0
                  ? "red-txt"
                  : "green-txt"
              }
            >
              {columnValues.chgper == undefined || null
                ? "0"
                : columnValues.chgper}{" "}
              %
            </span>
          </td>
          {/* {Object.keys(columnValues).map((value, index) => {
            return (
              <td key={index} className="snapshot-table-column">
                {index == 0 ? (
                  <>
                    <img
                      src={
                        columnValues[value] === 0
                          ? ""
                          : columnValues[value] < 0
                          ? Lowarrow
                          : UpArrow
                      }
                      alt=""
                    />
                    <>
                      {columnValues[value] == undefined || null
                        ? "0"
                        : columnValues[value]}
                    </>
                  </>
                ) : (
                  <span
                    className={
                      columnValues[value] == 0
                        ? "text-muted"
                        : columnValues[value] < 0
                        ? "red-txt"
                        : "green-txt"
                    }
                  >
                    {columnValues[value] == undefined || null
                      ? "0"
                      : columnValues[value]}
                  </span> 
                )}
              </td>
            );
          })} */}
        </tr>
      );
    });
  };

  const showRevenueEquModal = (revenueEquModel) => {
    return (
      revenueEquModel &&
      revenueEquModel.map((data, key) => {
        return (
          <tr key={key}>
            <td>
              <a
                href="/client-dashboard"
                onClick={() => {
                  goToClientDashboard(data.clientCode, "");
                  getTabStatus("")
                }}
              >
                {checkEmpty(data.clientCode) || data.clientCode == ""
                  ? "-"
                  : data.clientCode}
              </a>
            </td>
            <td>
              {checkEmpty(data.clientName) || data.clientName == ""
                ? "-"
                : data.clientName}
            </td>
            <td>
              {checkEmpty(data.isin) || data.isin == "" ? "-" : data.isin}
            </td>
            <td>{checkEmpty(data.pBrokDel) ? "-" : data.pBrokDel}</td>
            <td>
              {checkEmpty(data.pBrokTrd)
                ? "-"
                : numDifferentiationWithoutSymbol(data.pBrokTrd)}
            </td>
            <td>
              {checkEmpty(data.sBrokDel)
                ? "-"
                : numDifferentiationWithoutSymbol(data.sBrokDel)}
            </td>
            <td>{checkEmpty(data.sBrokTrd) ? "-" : data.sBrokTrd}</td>
            <td>{checkEmpty(data.saudaDate) ? "-" : data.saudaDate}</td>
            <td>{checkEmpty(data.scripCd) ? "-" : data.scripCd}</td>
            <td>{checkEmpty(data.scripName) ? "-" : data.scripName}</td>
          </tr>
        );
      })
    );
  };

  const showRevenueFnoModal = (revenueFnoModel) => {
    return (
      revenueFnoModel &&
      revenueFnoModel.map((data, key) => {
        return (
          <tr key={key}>
            <td>
              <a
                href="/client-dashboard"
                onClick={() => {
                  goToClientDashboard(data.clientCode, "");
                  getTabStatus("")
                }}
              >
                {checkEmpty(data.clientCode) ? "-" : data.clientCode}
              </a>
            </td>
            <td>{checkEmpty(data.clientName) ? "-" : data.clientName}</td>
            <td>{checkEmpty(data.pBrokAmt) ? "-" : data.pBrokAmt}</td>
            <td>{checkEmpty(data.sBrokAmt) ? "-" : data.sBrokAmt}</td>
            <td>{checkEmpty(data.saudaDate) ? "-" : data.saudaDate}</td>
            <td>
              {checkEmpty(data.strike_price)
                ? "-"
                : numDifferentiationWithoutSymbol(data.strike_price)}
            </td>
            <td>{checkEmpty(data.symbol) ? "-" : data.symbol}</td>
          </tr>
        );
      })
    );
  };

  const showRevenueMTFModal = (revenueMTFModel) => {
    return (
      revenueMTFModel &&
      revenueMTFModel.map((data, key) => {
        return (
          <tr key={key}>
            <td>
              <a
                href="/client-dashboard"
                onClick={() => {
                  goToClientDashboard(data.clientCode, "");
                  // Navigate("/client-dashboard");
                  getTabStatus("")
                }}
              >
                {checkEmpty(data.clientCode) ? "-" : data.clientCode}
              </a>
            </td>
            <td>{checkEmpty(data.scripName) ? "-" : data.scripName}</td>
            <td>{checkEmpty(data.orderNo) ? "-" : data.orderNo}</td>
            <td>{checkEmpty(data.tradeNo) ? "-" : data.tradeNo}</td>
            <td>{checkEmpty(data.orderTime) ? "-" : data.orderTime}</td>
            <td>{checkEmpty(data.symbol) ? "-" : data.symbol}</td>
            <td>{checkEmpty(data.marketRate) ? "-" : data.marketRate}</td>
            <td>{checkEmpty(data.saudaDate) ? "-" : data.saudaDate}</td>
            <td>{checkEmpty(data.brokerage) ? "-" : data.brokerage}</td>
          </tr>
        );
      })
    );
  };

  return (
    <div className="snapshot-detail-block revenue-detail revenue-report">
      <div className="card-title mb-0">
        <h2>{props.title}</h2>
        <div className="generate-btn-wrapper mt-0">
          <button
            className="generate-btn excel1 text-green"
            value="excel"
            onClick={(e) => handleFileType(e)}
          >
            {props?.buttonLoader?.excel ? (
              <SmallLoader />
            ) : (
              <>
                <span className="icon-excelsvg"></span>
                Excel
              </>
            )}
          </button>

          <button
            className="generate-btn pdf1 txt-purple"
            value="pdf"
            onClick={(e) => handleFileType(e)}
          >
            {props?.buttonLoader?.pdf ? (
              <SmallLoader />
            ) : (
              <>
                <span className="icon-pdfsvg"></span> PDF
              </>
            )}
          </button>
        </div>
      </div>

      <div className="snapshot-table scroll-table">
        <table className="table tabel-level1">
          <tr className="for-gap">
            <td>
              <table className="table table-level2">
                <thead>
                  <tr>
                    {/* <th className="header-width"></th> */}
                    <th
                      colSpan="3"
                      scope="col"
                      className="col-width-tab text-center"
                    >
                      {/* {Constants.Yesterday} */}
                      {Constants.Yesterday}
                      <br />
                      <span>{Constants.Compare_Yesterday}</span>
                    </th>
                  </tr>
                  <tr>
                    <></>
                    {/* <th className="header-width"></th> */}
                    <th scope="col"></th>
                    <th scope="col">{firstColumnTitle}</th>
                    <th scope="col">{Constants.Previous}</th>
                    <th scope="col">{Constants.Change}</th>
                    <th scope="col">{Constants.Change_Perc}</th>
                  </tr>
                </thead>
                <tbody>
                  {yesterday == null || undefined
                    ? handleifTableEmpty(true)
                    : generateOverallTableData(yesterday, true)}
                </tbody>
              </table>
            </td>
            <td>
              <table className="table table-level3">
                <thead>
                  <tr>
                    {/* <th className="header-width"></th> */}
                    <th
                      colSpan="3"
                      scope="col"
                      className="col-width-tab text-center"
                    >
                      {Constants.Current_Week}
                      <br />
                      <span>{Constants.Compare_Week}</span>
                    </th>
                  </tr>
                  <tr>
                    {/* <th className="header-width"></th> */}
                    <th scope="col">{firstColumnTitle}</th>
                    <th scope="col">{Constants.Previous}</th>
                    {/* <th scope="col">
                      {Constants.Change}
                      <br />
                      {Constants.Change_Perc}
                    </th> */}
                    <th scope="col">{Constants.Change}</th>
                    <th scope="col">{Constants.Change_Perc}</th>
                  </tr>
                </thead>
                <tbody>
                  {weekly == null || undefined
                    ? handleifTableEmpty()
                    : generateSnapshotTableData(weekly, "Weekly")}
                </tbody>
              </table>
            </td>
            <td>
              <table className="table table-level4">
                <thead>
                  <tr>
                    {/* <th className="header-width"></th> */}
                    <th
                      colSpan="3"
                      scope="col"
                      className="col-width-tab text-center"
                    >
                      {Constants.Current_Month}
                      <br />
                      <span>{Constants.Compare_Month}</span>
                    </th>
                  </tr>
                  <tr>
                    {/* <th className="header-width"></th> */}
                    <th scope="col">{firstColumnTitle}</th>
                    <th scope="col">{Constants.Previous}</th>
                    {/* <th scope="col">
                      {Constants.Change}
                      <br />
                      {Constants.Change_Perc}
                    </th> */}
                    <th scope="col">{Constants.Change}</th>
                    <th scope="col">{Constants.Change_Perc}</th>
                  </tr>
                </thead>
                <tbody>
                  {month == null || undefined
                    ? handleifTableEmpty()
                    : generateSnapshotTableData(month, "Monthly")}
                </tbody>
              </table>
            </td>
            <td>
              <table className="table table-level5">
                <thead>
                  <tr>
                    {/* <th className="header-width"></th> */}
                    <th
                      colSpan="3"
                      scope="col"
                      className="col-width-tab text-center"
                    >
                      {Constants.Current_Year}
                      <br />
                      <span>{Constants.Compare_Year}</span>
                    </th>
                  </tr>
                  <tr>
                    {/* <th className="header-width"></th> */}
                    <th scope="col">{firstColumnTitle}</th>
                    <th scope="col">{Constants.Previous}</th>
                    <th scope="col">{Constants.Change} </th>
                    <th scope="col">{Constants.Change_Perc}</th>

                    {/* <th scope="col">{Constants.Change}</th>
                    <th scope="col">{Constants.Change_Perc}</th> */}
                  </tr>
                </thead>
                <tbody>
                  {year == null || undefined
                    ? handleifTableEmpty()
                    : generateSnapshotTableData(year, "Yearly")}
                </tbody>
              </table>
            </td>
          </tr>
        </table>
      </div>
      <Modal
        show={showModal}
        // onHide={() => setShowModal(false)
        // }
        onHide={onHide}
        size="lg"
        aria-labelledby="contained-modal-title-vcenter"
        centered
        className="inactive-modal setting-model"
        backdrop="static"
        keyboard={false}
      >
        <Modal.Header className="mb-4 modal-header">
          <Modal.Title id="contained-modal-title-vcenter modal-title">
            <p>{Constants.Revenue_Snapshot}</p>
          </Modal.Title>
          <button
            type="button"
            className="btn-close"
            aria-label="Close"
            onClick={onHide}
          >
            <span className="icon-close"></span>
          </button>
        </Modal.Header>
        <Modal.Body>
          <div className="table-responsive scroll-table model-top-active-table">
            {loader ? (
              <div className="loader-alignment">
                <Loader />
              </div>
            ) : revenueEquModel && revenueEquModel.length > 0 ? (
              <table className="table">
                <thead>
                  <tr>
                    <th>{Constants.Client_Code}</th>
                    <th>{Constants.client_Name}</th>
                    <th>{Constants.Isin}</th>
                    <th>PBrok Del</th>
                    <th>PBrok Trd</th>
                    <th>SBrok Del</th>
                    <th>SBrok Trd</th>
                    <th>{Constants.Sauda_Date}</th>
                    <th>{Constants.Scrip_Code}</th>
                    <th>{Constants.Scrip_Name}</th>
                  </tr>
                </thead>

                <tbody id="revenue-equ" onScroll={handleScroll}>
                  {showRevenueEquModal(revenueEquModel)}
                  {/* <div className="equity-center">
                    {infiniteScrollLoader && <Loader />}
                  </div> */}
                </tbody>
              </table>
            ) : serverError ===
              "Something went wrong, Please try again later." ? (
              <h4 className="no-data">{serverError}</h4>
            ) : (
              noDataFound()
            )}
          </div>

          <div className="generate-btn-wrapper">
            <button
              className="generate-btn text-green"
              value="excel"
              // onClick={handleFileType}
              onClick={(e) => {
                getRevenueSnapshotEquityModel(duration, e.target.value, -1);
              }}
            >
              {smallLoaderExcel ? (
                <SmallLoader />
              ) : (
                <>
                  <span className="icon-excelsvg"></span>
                  {"Excel"}
                </>
              )}
            </button>
            <button
              className="generate-btn txt-purple"
              value="pdf"
              // onClick={handleFileType}
              onClick={(e) => {
                getRevenueSnapshotEquityModel(duration, e.target.value, -1);
              }}
            >
              {smallLoaderPdf ? (
                <SmallLoader />
              ) : (
                <>
                  <span className="icon-pdfsvg"></span> {"PDF"}
                </>
              )}
            </button>
          </div>
        </Modal.Body>
      </Modal>

      <Modal
        show={showModelFno}
        // onHide={() => setShowModal(false)
        // }
        onHide={onHideFno}
        size="lg"
        aria-labelledby="contained-modal-title-vcenter"
        centered
        className="inactive-modal setting-model"
        backdrop="static"
        keyboard={false}
      >
        <Modal.Header className="mb-4 modal-header">
          <Modal.Title id="contained-modal-title-vcenter modal-title">
            <p>{Constants.Revenue_Snapshot}</p>
          </Modal.Title>
          <button
            type="button"
            className="btn-close"
            aria-label="Close"
            onClick={onHideFno}
          >
            <span className="icon-close"></span>
          </button>
        </Modal.Header>
        <Modal.Body>
          <div className="table-responsive scroll-table model-top-active-table">
            {loader ? (
              <div className="loader-alignment">
                <Loader />
              </div>
            ) : revenueFnoModel && revenueFnoModel.length > 0 ? (
              <table className="table">
                <thead>
                  <tr>
                    <th>{Constants.Client_Code}</th>
                    <th>{Constants.client_Name}</th>
                    <th>PBrok Amount</th>
                    <th>SBrok Amount</th>
                    <th>{Constants.Sauda_Date}</th>
                    <th>{Constants.Strike_Price}</th>
                    <th>{Constants.Symbol}</th>
                  </tr>
                </thead>

                <tbody id="revenue-fno" onScroll={handleScroll}>
                  {showRevenueFnoModal(revenueFnoModel)}
                  {/* <div className="equity-center">
                    {infiniteScrollLoader && <Loader />}
                  </div> */}
                </tbody>
              </table>
            ) : serverError ===
              "Something went wrong, Please try again later." ? (
              <h4 className="no-data">{serverError}</h4>
            ) : (
              noDataFound()
            )}
          </div>

          <div className="generate-btn-wrapper">
            <button
              className="generate-btn text-green"
              value="excel"
              onClick={(e) =>
                getRevenueSnapshotFnoModel(duration, e.target.value, -1)
              }
            >
              {smallLoaderExcel ? (
                <SmallLoader />
              ) : (
                <>
                  <span className="icon-excelsvg"></span>
                  {"Excel"}
                </>
              )}
            </button>
            <button
              className="generate-btn txt-purple"
              value="pdf"
              onClick={(e) =>
                getRevenueSnapshotFnoModel(duration, e.target.value, -1)
              }
            >
              {smallLoaderPdf ? (
                <SmallLoader />
              ) : (
                <>
                  <span className="icon-pdfsvg"></span> {"PDF"}
                </>
              )}
            </button>
          </div>
        </Modal.Body>
      </Modal>
      <Modal
        show={showModelMTF}
        // onHide={() => setShowModal(false)
        // }
        onHide={onHideMTF}
        size="lg"
        aria-labelledby="contained-modal-title-vcenter"
        centered
        className="inactive-modal setting-model"
        backdrop="static"
        keyboard={false}
      >
        <Modal.Header className="mb-4 modal-header">
          <Modal.Title id="contained-modal-title-vcenter modal-title">
            <p>{Constants.Revenue_Snapshot}</p>
          </Modal.Title>
          <button
            type="button"
            className="btn-close"
            aria-label="Close"
            onClick={onHideMTF}
          >
            <span className="icon-close"></span>
          </button>
        </Modal.Header>
        <Modal.Body>
          <div className="table-responsive scroll-table model-top-active-table">
            {loader ? (
              <div className="loader-alignment">
                <Loader />
              </div>
            ) : revenueMTFModel && revenueMTFModel.length > 0 ? (
              <table className="table">
                <thead>
                  <tr>
                    <th>{Constants.Client_Code}</th>
                    <th>Scrip Name</th>
                    <th>Order Number</th>
                    <th>Trade Number</th>
                    <th>Order Time</th>
                    <th>{Constants.Symbol}</th>
                    <th>Market Rate</th>
                    <th>{Constants.Sauda_Date}</th>
                    <th>Brokerage</th>
                  </tr>
                </thead>

                <tbody id="revenue-mtf" onScroll={handleScroll}>
                  {showRevenueMTFModal(revenueMTFModel)}
                  {/* <div className="equity-center">
                    {infiniteScrollLoader && <Loader />}
                  </div> */}
                </tbody>
              </table>
            ) : serverError ===
              "Something went wrong, Please try again later." ? (
              <h4 className="no-data">{serverError}</h4>
            ) : (
              noDataFound()
            )}
          </div>

          <div className="generate-btn-wrapper">
            <button
              className="generate-btn text-green"
              value="excel"
              onClick={(e) =>
                getRevenueSnapshotMTFModel(duration, e.target.value, -1)
              }
            >
              {smallLoaderExcel ? (
                <SmallLoader />
              ) : (
                <>
                  <span className="icon-excelsvg"></span>
                  {"Excel"}
                </>
              )}
            </button>
            <button
              className="generate-btn txt-purple"
              value="pdf"
              onClick={(e) =>
                getRevenueSnapshotMTFModel(duration, e.target.value, -1)
              }
            >
              {smallLoaderPdf ? (
                <SmallLoader />
              ) : (
                <>
                  <span className="icon-pdfsvg"></span> {"PDF"}
                </>
              )}
            </button>
          </div>
        </Modal.Body>
      </Modal>
    </div>
  );
}

export default React.memo(RevenueSnapshot);
